import appConfig from 'configs/app.config';
import firebase from 'firebase/app';
import 'firebase/messaging';

const firebaseConfig = {
  apiKey: appConfig.firebaseApiKey,
  projectId: appConfig.firebaseProjectId,
  messagingSenderId: appConfig.fcmSenderId,
  appId: appConfig.firebaseAppId,
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const messaging = firebase.messaging.isSupported()
  ? firebaseApp.messaging()
  : null;

export { messaging };
